<div class="divContent">
    <mat-accordion class="acordeonContent">
        <mat-expansion-panel hideToggle [expanded]="panelOpenState" class="mat-elevation-z4">
            <mat-expansion-panel-header class="acordeonHeader" (click)="ocultarMostrar()">
                <div class="topTitle">
                    <mat-card class="titleSeccion">
                        <span *ngIf="!editarValor">Crear estudio médico</span>
                        <span *ngIf="editarValor">Editar estudio médico</span>
                        <mat-icon *ngIf="!panelOpenState" class="iconArrow">keyboard_arrow_down</mat-icon>
                        <mat-icon *ngIf="panelOpenState" class="iconArrow">keyboard_arrow_up</mat-icon>
                    </mat-card>
                </div>
            </mat-expansion-panel-header>

            <form [formGroup]="estudioMedicoForm" (submit)="guardarEstudioMedico(estudioMedicoForm.value)" class="formCard">
                <div class="card">
                    <div class="formGroup">
                        <input hidden matInput formControlName="id">
                    </div>
                    <div class="formGroup">
                        <mat-form-field class="example-full-width input" appearance="fill">
                            <mat-label>Nombre</mat-label>
                            <input formControlName="texto" type="text" matInput (ngModelChange)="clearTexto()">
                        </mat-form-field>
                        <span style="color:rgb(236,75,72);" *ngIf="estudioMedicoForm.get('texto').invalid && (estudioMedicoForm.get('texto').dirty || estudioMedicoForm.get('texto').touched)">
                            El texto es requerido
                        </span>
                        <span style="color:rgb(236,75,72);" *ngIf="errorTexto && estudioMedicoForm.get('texto').touched">
                            El texto fue registrado por otro estudio médico
                        </span>
                    </div>
                    <div class="formButton">
                        <button *ngIf="!editarValor" mat-raised-button class="buttonForm">Crear</button>
                        <button *ngIf="editarValor" mat-raised-button class="buttonForm Cancelar"routerLink="../../">Cancelar</button>
                        <button *ngIf="editarValor" mat-raised-button class="buttonForm">Editar</button>
                    </div>
                </div>
            </form>

        </mat-expansion-panel>
    </mat-accordion>
</div>